/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_RealsInputs */

const cs_enum_reals = /** @type {(inputs: Enum_RealsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reals`)
};

const en_enum_reals = /** @type {(inputs: Enum_RealsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reals`)
};

/**
* | output |
* | --- |
* | "Reals" |
*
* @param {Enum_RealsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_reals = /** @type {((inputs?: Enum_RealsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_RealsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_reals(inputs)
	return cs_enum_reals(inputs)
});